export function recVal(obj: Record<string, unknown>, key: string, defaultVal: any) {
  if (['string', 'number'].indexOf(typeof key) >= 0) {
    const keys = key.toString().split('.');
    let tmp: any = Array.isArray(obj) ? obj : { ...obj };
    let reachedLastKey = false;
    keys.forEach((k, inx) => {
      if (tmp !== undefined) {
        const tmpObject = tmp;

        if (tmpObject[k] !== undefined) {
          tmp = tmpObject[k];

          if ((inx + 1) === keys.length) {
            reachedLastKey = true;
          }
        }
      }
    });

    if (reachedLastKey) {
      return tmp;
    }
  }

  return defaultVal;
}

export function getAppConfig(key: string, fallback: any = undefined) {
  const appConfig = (window.ioAppConfig || {}) as unknown as Record<string, unknown>;

  return recVal(appConfig, key, fallback);
}
